import React from "react";
import PortableText from "react-portable-text";

const ShowcaseContent = ({ header, content }: any) => {
  return (
    <div
      className="lg:basis-3/4 md:basis-2/3 md:max-h-max max-h-72 md:relative sticky top-0 
      bg-white md:overflow-visible overflow-scroll basis-1/2 md:pr-5 border-b-4 md:border-0
      md:border-r-[1px] border-natural-grey-200 px-4 md:px-0"
    >
      <div className="sticky top-5 my-5">
        <h2 className="text-3xl font-semibold mb-5">{header}</h2>

        {content ? (
          <PortableText
            content={content}
            serializers={{
              container: (props: any) => (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    wordSpacing: "2px",
                    lineHeight: "1.5",
                  }}
                  {...props}
                />
              ),
              h1: (props: any) => (
                <h1
                  style={{
                    fontSize: "2rem",
                    fontWeight: "900",
                  }}
                  {...props}
                />
              ),
              h2: (props: any) => (
                <h2
                  style={{
                    fontSize: "1.7rem",
                    fontWeight: "700",
                  }}
                  {...props}
                />
              ),
              h3: (props: any) => (
                <h3
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "600",
                  }}
                  {...props}
                />
              ),
              h4: (props: any) => (
                <h4
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "500",
                  }}
                  {...props}
                />
              ),
              h5: (props: any) => (
                <h5
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "500",
                  }}
                  {...props}
                />
              ),
              h6: (props: any) => (
                <h6
                  style={{
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                  {...props}
                />
              ),
              normal: (props: any) => (
                <p
                  style={{
                    fontSize: "1rem",
                    fontWeight: "400",
                    lineHeight: "1.5rem",
                  }}
                  {...props}
                />
              ),
              link: (props: any) => (
                <a
                  style={{
                    color: "blue",
                  }}
                  {...props}
                />
              ),
              ul: (props: any) => (
                <ul
                  style={{
                    listStyleType: "disc",
                    marginLeft: "1.5rem",
                    marginTop: "0.5em",
                  }}
                  {...props}
                />
              ),
              em: (props: any) => (
                <em
                  style={{
                    fontStyle: "italic",
                  }}
                  {...props}
                />
              ),
              strong: (props: any) => (
                <strong
                  style={{
                    fontWeight: "bold",
                  }}
                  {...props}
                />
              ),
              blockquote: (props: any) => (
                <blockquote
                  style={{
                    borderLeft: "5px solid #ccc",
                    fontStyle: "italic",
                  }}
                  {...props}
                />
              ),
            }}
            projectId={process.env.NEXT_PUBLIC_PROJECT_ID}
            dataset={process.env.NEXT_PUBLIC_DATASET}
          />
        ) : null}
      </div>
    </div>
  );
};

export default ShowcaseContent;
